module.exports = __webpack_public_path__ + "static/media/key-area-3.12c47b53.png";